import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RouterHistoryService {
  private _assetBackDestination = '/assets';

  private history: string[] = [];
  private maxHistorySize = 50;
  private skipUrl = [
    /\/brand-portal\/article\/\d+/,
    /\?assetId=/,
    /\/assets\/detail\/[a-f0-9]+\/((?!asset-info)[a-z-]+)/,
    /\/collections\/collection-asset-list\/[a-f0-9]+\/((?!collection-assets)[a-z-]+)/,
  ];

  constructor(private router: Router) {
    this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      const url = event.url !== '/' ? event.urlAfterRedirects : '';
      if (url && !this.shouldSkipUrl(url)) {
        if (this.history.length >= this.maxHistorySize) {
          this.history.shift();
        }
        this.history.push(url);
        this.history = this.removeLastDuplicate(this.history);
      }
    });
  }

  private removeLastDuplicate(history: string[]) {
    const historyCopy = [...history];

    const lastIndex = historyCopy.length - 1;

    if (lastIndex > 0 && historyCopy[lastIndex] === historyCopy[lastIndex - 1]) {
      historyCopy.splice(lastIndex, 1);
    }

    return historyCopy;
  }

  private shouldSkipUrl(url: string): boolean {
    return this.skipUrl.some((pattern) => pattern.test(url));
  }

  get assetBackDestination() {
    if (this.history.length > 1) {
      this.clearSameHistoryLevel();

      const previousUrl = this.history.pop();
      if (previousUrl) {
        this._assetBackDestination = previousUrl;
      }
    } else {
      this._assetBackDestination = this.router.url.includes('/collections/collection-asset-list/') ? '/collections' : this._assetBackDestination;
    }

    return this._assetBackDestination;
  }

  private clearSameHistoryLevel() {
    let lastUrl = this.history.at(-1) as string;
    // If lastUrl is the "same level" as the current route, remove it from the history
    while (lastUrl && this.getIsCurrentLevel(lastUrl)) {
      this.history.pop();
      lastUrl = this.history.at(-1) as string;
    }
  }

  // example: should be true if params are "collections/collection-asset-list/.../collection-assets" and "collections/collection-asset-list/.../general-info"
  // and also different assets like "assets/detail/034da...0430/asset-info" and "assets/detail/034da...0430/asset-info"
  private getIsCurrentLevel(targetUrl: string, currentUrl: string = this.router.url): boolean {
    const target = targetUrl.split('/').slice(0, 3).join('');
    const current = currentUrl.split('/').slice(0, 3).join('');

    return target === current;
  }
}
